var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTrending = function SvgTrending(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M51 28c0 12.703-10.297 23-23 23S5 40.703 5 28 15.298 5 28 5s23 10.298 23 23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M31.39 22.396a1 1 0 0 0 .76.591l9.458 1.517-6.847 5.464a1 1 0 0 0-.353 1l2.004 9-7.904-4.661a1 1 0 0 0-1.016 0l-7.904 4.661 2.003-9a1 1 0 0 0-.352-1l-6.847-5.464 9.459-1.517a1 1 0 0 0 .76-.591L28 14.528z"
  })));
};
export default SvgTrending;